export default "__VITE_ASSET__DlnP9gyT__"